<template>
  <div>
    <b-card no-body>

      <b-card-body class="bg-light pb-5">
        <div class="row">
          <div class="col-12 col-lg-8 mb-3">
            <b-card no-body class="shadow-sm border-0 rounded-lg overflow-hidden">
              <b-table hover responsive borderless :items="tables" :fields="tableFields" :busy="loading" @row-clicked="onRowClicked" :style="{ fontSize: isMobile ? '12px' : '14px' }" class="mb-0" tbody-tr-class="cursor-pointer">
                <template #table-busy>
                  <div class="text-center text-primary my-5">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">加载中...</strong>
                  </div>
                </template>
                <template #cell(updated_time)="{ value }">
                  <span class="text-muted" style="white-space: nowrap;"><b-icon icon="clock" class="mr-1"></b-icon>{{ formatTime(value) }}</span>
                </template>
                <template #cell(name)="{ value }">
                  <span class="font-weight-bold text-primary" style="font-size: 1.05em;">{{ value }}</span>
                </template>
                <template #cell(created_time)="{ value }">
                  <span class="text-muted" style="white-space: nowrap;">{{ formatTime(value) }}</span>
                </template>
                <template #cell(content)="{ value }">
                  <div class="text-muted" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; white-space: normal; line-height: 1.4; font-size: 0.9em;" :title="value">{{ value }}</div>
                </template>
                <template #cell(actions)="{ item }">
                  <b-button size="sm" variant="outline-primary" class="mr-1 rounded-pill" @click.stop="selectTable(item)" title="查看详情">
                   <span class="d-none d-md-inline">进入详情</span> <b-icon icon="arrow-right-short"></b-icon>
                  </b-button>
                  <b-button v-if="canEdit" size="sm" variant="outline-secondary" class="rounded-pill" @click.stop="editTable(item)" title="编辑">
                    <b-icon icon="pencil"></b-icon>
                  </b-button>
                </template>
              </b-table>
            </b-card>

            <div class="mt-3 d-flex flex-wrap justify-content-between align-items-center">
              <div class="d-flex align-items-center mb-2 mb-md-0">
                <b-button size="sm" variant="primary" class="mr-2 px-3 shadow-sm rounded-pill" @click="loadTables(currentPage)" :disabled="loading">
                  <b-icon icon="arrow-clockwise" :animation="loading ? 'spin' : ''"></b-icon> <span class="d-none d-md-inline">刷新</span>
                </b-button>
                <b-badge variant="info" class="px-2 py-1 rounded-pill shadow-sm">{{ tables.length }} 个题材库</b-badge>
              </div>
              <b-pagination v-if="totalRows > perPage" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" class="mb-0" @change="loadTables"></b-pagination>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <b-card title="识别与创建" v-if="canEdit">
              <b-form-group label="快速导入 (韭研公社)" class="mb-3">
                 <b-input-group size="sm">
                   <b-form-input v-model="jygsUrl" placeholder="链接或ID"></b-form-input>
                   <b-input-group-append>
                     <b-button variant="outline-primary" @click="identifyJygs" :disabled="identifying">
                        <b-spinner small v-if="identifying"></b-spinner>
                        {{ identifying ? '' : '识别' }}
                     </b-button>
                   </b-input-group-append>
                 </b-input-group>
              </b-form-group>
              <b-form-group label="名称">
                <b-form-input v-model="form.name" placeholder="请输入名称"></b-form-input>
              </b-form-group>
              <div class="row">
                <div class="col-6">
                  <b-form-group label="创建时间">
                    <b-form-input v-model="form.create_time" size="sm" placeholder="自动获取"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-6">
                  <b-form-group label="更新时间">
                    <b-form-input v-model="form.update_time" size="sm" placeholder="自动获取"></b-form-input>
                  </b-form-group>
                </div>
              </div>
              <b-form-group label="内容">
                <b-form-textarea v-model="form.content" rows="3" max-rows="6" placeholder="请输入内容"></b-form-textarea>
              </b-form-group>
              <b-form-group label="图片来源">
                <b-form-file v-model="form.image" accept="image/*" @input="onImageChange" placeholder="选择本地图片..." class="mb-2"></b-form-file>
                <b-input-group size="sm">
                   <b-input-group-prepend is-text>URL</b-input-group-prepend>
                   <b-form-input v-model="form.image_url" placeholder="或输入图片URL" @input="onImageUrlChange"></b-form-input>
                </b-input-group>
              </b-form-group>
              <div v-if="imagePreview" class="mb-2">
                <img :src="imagePreview" alt="预览" style="max-width:100%" />
              </div>
              <div class="d-flex">
                <b-button size="sm" variant="primary" class="mr-2" :disabled="submitting || (!form.image && !form.image_url)" @click="recognizeImage">识别图片</b-button>
                <b-button size="sm" variant="success" :disabled="submitting || !form.name" @click="createTable">创建表格</b-button>
              </div>
              <b-alert :show="ocrMsg!==''" variant="info" class="mt-2">{{ ocrMsg }}</b-alert>
            </b-card>
            <b-alert v-else show variant="light" class="small text-muted">
              当前账号无创建/编辑权限（需要角色：post）。如需开通，请联系管理员。
            </b-alert>
          </div>
        </div>

        <div v-if="recognized.length || showRecognitionArea" class="mt-3">
          <b-card title="识别结果">
            <div class="d-flex justify-content-between mb-2">
              <div>
                <b-button size="sm" variant="success" @click="addRecognizedRow" v-if="recognitionView==='table'">新增一行</b-button>
              </div>
              <b-button-group size="sm">
                <b-button :variant="recognitionView==='table'?'primary':'outline-secondary'" @click="()=>{ if(recognitionView==='json') syncRecognitionJsonToTable(); recognitionView='table' }">表格</b-button>
                <b-button :variant="recognitionView==='json'?'primary':'outline-secondary'" @click="switchToRecognitionJsonMode">JSON</b-button>
              </b-button-group>
            </div>
            <b-table v-if="recognitionView==='table'" small striped hover responsive :items="recognized" :fields="recognizedFields" :style="{ fontSize: isMobile ? '8px' : '' }">
              <template #cell(一级大类)="{ item }"><b-form-input v-model="item['一级大类']" size="sm"></b-form-input></template>
              <template #cell(二级小类)="{ item }"><b-form-input v-model="item['二级小类']" size="sm"></b-form-input></template>
              <template #cell(三级细分)="{ item }"><b-form-input v-model="item['三级细分']" size="sm"></b-form-input></template>
              <template #cell(个股)="{ item }"><b-form-input v-model="item['个股']" size="sm"></b-form-input></template>
              <template #cell(涨跌幅)="{ item }">
                <b-form-input v-if="isEditing" v-model="item['涨跌幅']" size="sm"></b-form-input>
                <span v-else :style="[getRateStyle(item['涨跌幅']), {cursor: 'pointer'}]" @click.stop="openSidebar(item)">{{ item['涨跌幅'] }}<span v-if="item['涨跌幅']">%</span></span>
              </template>
              <template #cell(相关性)="{ item }"><b-form-input v-model="item['相关性']" size="sm"></b-form-input></template>
              <template #cell(信息源)="{ item }"><b-form-input v-model="item['信息源']" size="sm"></b-form-input></template>
              <template #cell(actions)="{ index }">
                <b-button size="sm" variant="danger" @click="recognized.splice(index, 1)">删除</b-button>
              </template>
            </b-table>
            <div v-if="recognitionView==='json'" class="mt-2">
              <b-form-textarea
                v-model="recognitionJsonStr"
                placeholder="请输入JSON数据（对象数组格式）..."
                rows="15"
                max-rows="30"
                @blur="syncRecognitionJsonToTable"
              ></b-form-textarea>
              <b-alert :show="!!recognitionJsonError" variant="danger" class="mt-2">{{ recognitionJsonError }}</b-alert>
            </div>
          </b-card>
        </div>


      </b-card-body>
    </b-card>
    <StockInfoSidebar :symbol_code="sidebarSymbolCode" :symbol_name="sidebarSymbolName" :date_mark="sidebarDateMark" />
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'
import StockInfoSidebar from '@/components/stock/StockInfoSidebar'

export default {
  components: { StockInfoSidebar },
  data(){
    return {
      windowWidth: window.innerWidth,
      theme: 'light',
      tables: [],
      tableFields: [ 
        { key:'updated_time', label:'更新时间', sortable:true, class: 'text-center align-middle d-none d-md-table-cell', thClass: 'text-center d-none d-md-table-cell', thStyle: { width: '150px' } }, 
        { key:'name', label:'名称', sortable:true, class: 'align-middle', thStyle: { width: '30%' } }, 
        { key:'content', label:'内容', class: 'align-middle', thStyle: { width: '40%' } },
        { key:'created_time', label:'创建时间', sortable:true, class: 'text-center align-middle d-none d-md-table-cell', thClass: 'd-none d-md-table-cell', thStyle: { width: '150px' } }, 
        { key:'actions', label:'详情', class: 'text-right align-middle', thClass: 'text-right', thStyle: { width: '120px' } } 
      ],

      loading: false,
      submitting: false,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      jygsUrl: '',
      identifying: false,
      form: { name:'', content:'', image:null, image_url:'', create_time:'', update_time:'' },
      imagePreview: '',
      recognized: [],
      ocrMsg: '',
      recognizedFields: [ { key:'一级大类', label:'一级大类' }, { key:'二级小类', label:'二级小类' }, { key:'三级细分', label:'三级细分' }, { key:'个股', label:'个股' }, { key:'相关性', label:'相关性' }, { key:'信息源', label:'信息源' }, { key:'actions', label:'详情' } ],
      recognitionView: 'table',
      recognitionJsonStr: '',
      recognitionJsonError: '',
      showRecognitionArea: false,
      showEdit: false,
      editId: null,
      editForm: { name:'', content:'', rows:[], image: null, created_time: '', updated_time: '' },
      editImagePreview: '',
      editOcrMsg: '',
      isEditing: false,
      viewMode: 'table',
      mindMapOption: {},
      mindMapStyle: 'LR',
      mindMapCurve: 'curve',
      mindMapSymbol: 'emptyCircle',
      loadingStocks: false,
      jsonStr: '',
      jsonError: '',
      lastQuoteTime: '',
      contentCollapsed: true,
      showQuotes: false,
      sidebarSymbolCode: '',
      sidebarSymbolName: '',
      sidebarDateMark: ''
    }
  },
  computed:{
    isMobile() {
      return this.windowWidth < 768
    },
    canEdit(){
      try{
        const raw = localStorage.getItem('user_info')
        if(!raw) return false
        const u = JSON.parse(raw)
        const r = u && u.roles
        const arr = Array.isArray(r) ? r : String(r||'').split(',').map(s=>s.trim()).filter(Boolean)
        return arr.includes('post')
      }catch(e){ return false }
    },
    modalTableFields(){
      try{
        const base = Array.isArray(this.recognizedFields) ? this.recognizedFields : []
        let fields = base.slice()
        if(!this.showQuotes){
          fields = fields.filter(f => f.key !== '流通市值' && f.key !== '最新价' && f.key !== '涨跌幅')
        } else {
          const hasCap = fields.some(f => f.key === '流通市值')
          const hasPrice = fields.some(f => f.key === '最新价')
          const hasRate = fields.some(f => f.key === '涨跌幅')
          if(!hasCap) fields.splice(4, 0, { key:'流通市值', label:'流通市值' })
          if(!hasPrice) fields.splice(5, 0, { key:'最新价', label:'当前价格' })
          if(!hasRate) fields.splice(6, 0, { key:'涨跌幅', label:'涨跌幅' })
          const hasCode = fields.some(f => f.key === 'symbol_code')
          if(!hasCode) fields.splice(4, 0, { key:'symbol_code', label:'股票代码' })
        }
        if(this.isEditing) return fields
        return fields.filter(f => f.key !== 'actions')
      }catch(e){
        return (this.recognizedFields || []).filter(f => f.key !== 'actions')
      }
    },
    mergedRows(){
      try{
        const src = Array.isArray(this.editForm.rows) ? this.editForm.rows : []
        const rows = src.map(r => ({
          ...r,
          _l1Show: true, _l1Span: 1,
          _l2Show: true, _l2Span: 1,
          _l3Show: true, _l3Span: 1
        }))
        const n = rows.length
        let i = 0
        while (i < n) {
          const l1 = (rows[i]['一级大类'] || '').trim()
          let j = i + 1
          while (j < n && (rows[j]['一级大类'] || '').trim() === l1) j++
          rows[i]._l1Show = true
          rows[i]._l1Span = j - i
          for (let k = i + 1; k < j; k++) { rows[k]._l1Show = false }
          let k = i
          while (k < j) {
            const l2 = (rows[k]['二级小类'] || '').trim()
            let m = k + 1
            while (m < j && (rows[m]['二级小类'] || '').trim() === l2) m++
            rows[k]._l2Show = true
            rows[k]._l2Span = m - k
            for (let t = k + 1; t < m; t++) { rows[t]._l2Show = false }
            let t = k
            while (t < m) {
              const l3 = (rows[t]['三级细分'] || '').trim()
              let u = t + 1
              while (u < m && (rows[u]['三级细分'] || '').trim() === l3) u++
              rows[t]._l3Show = true
              rows[t]._l3Span = u - t
              for (let v = t + 1; v < u; v++) { rows[v]._l3Show = false }
              t = u
            }
            k = m
          }
          i = j
        }
        return rows
      }catch(e){
        return this.editForm.rows || []
      }
    }
  },
  mounted(){ 
    this.loadTables()
    window.addEventListener('paste', this.handlePaste)
    window.addEventListener('resize', this.onResize)
    
    try{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }catch(e){ console.warn('theme read failed', e) }
    this.onThemeChanged = (e)=>{ const theme = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = theme; this.generateMindMap() }
    window.addEventListener('site-theme-changed', this.onThemeChanged)
  },
  beforeDestroy() {
    window.removeEventListener('paste', this.handlePaste)
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('site-theme-changed', this.onThemeChanged)
  },
  methods:{
    onResize() {
      this.windowWidth = window.innerWidth
    },
    formatTime(val) {
      if (!val) return ''
      if (this.isMobile && typeof val === 'string' && val.length >= 16) {
        // Assume format YYYY-MM-DD HH:mm:ss, remove YYYY- and :ss
        // Returns MM-DD HH:mm
        return val.substring(5, 16)
      }
      return val
    },
    formatYi(val){
      if (val === undefined || val === null || val === '') return ''
      const n = parseFloat(val)
      if (isNaN(n)) return String(val)
      const yi = n / 100000000
      return yi.toFixed(2) + '亿'
    },
    downloadTableImage(){
      try{
        const showQ = this.showQuotes
        const header = showQ 
          ? ['一级大类','二级小类','三级细分','个股','股票代码','流通市值','当前价格','涨跌幅','相关性','信息源']
          : ['一级大类','二级小类','三级细分','个股','相关性','信息源']
        const colWidths = showQ 
          ? [140,140,160,160,120,130,110,90,320,220]
          : [140,140,160,180,320,220]
        const paddingX = 10
        const paddingY = 8
        const font = '12px sans-serif'
        const rows = Array.isArray(this.mergedRows) ? this.mergedRows : []
        const ctx = document.createElement('canvas').getContext('2d')
        ctx.font = font
        const wrap = (text, maxWidth) => {
          const t = String(text || '')
          const words = t.split(/\s+/)
          const lines = []
          let line = ''
          const pushLine = (s) => { lines.push(s) }
          const measure = (s) => ctx.measureText(s).width
          if (!words.length) return ['']
          for (let i=0;i<words.length;i++){
            const w = words[i]
            const test = line ? (line + ' ' + w) : w
            if (measure(test) + paddingX*2 <= maxWidth) {
              line = test
            } else {
              if (line) pushLine(line)
              if (measure(w) + paddingX*2 <= maxWidth) {
                line = w
              } else {
                let part = ''
                for (let j=0;j<w.length;j++){
                  const test2 = part + w[j]
                  if (measure(test2) + paddingX*2 <= maxWidth) part = test2
                  else { if (part) pushLine(part); part = w[j] }
                }
                line = part
              }
            }
          }
          if (line) pushLine(line)
          const byNewline = t.split('\n')
          if (byNewline.length > 1) return t.split('\n')
          return lines.length ? lines : [t]
        }
        const colCount = header.length
        const IDX = {
          L1: 0, L2: 1, L3: 2, STOCK: 3,
          CODE: showQ ? 4 : -1,
          CAP: showQ ? 5 : -1,
          PRICE: showQ ? 6 : -1,
          RATE: showQ ? 7 : -1,
          REL: showQ ? 8 : 4,
          SRC: showQ ? 9 : 5
        }
        const tableWidth = colWidths.reduce((a,b)=>a+b,0)
        const rowBaseHeight = 26
        const rowHeights = []
        for (let i=0;i<rows.length;i++){
          const r = rows[i]
          const relLines = wrap(r['相关性'], colWidths[IDX.REL])
          const srcLines = wrap(r['信息源'], colWidths[IDX.SRC])
          const lh = Math.max(relLines.length, srcLines.length, 1)
          rowHeights.push(Math.max(rowBaseHeight, lh * 18))
        }
        let totalHeight = 40
        for (let i=0;i<rowHeights.length;i++) totalHeight += rowHeights[i]
        totalHeight += 40
        const canvas = document.createElement('canvas')
        canvas.width = tableWidth + 2
        canvas.height = totalHeight
        const c = canvas.getContext('2d')
        c.fillStyle = '#ffffff'
        c.fillRect(0,0,canvas.width,canvas.height)
        c.save()
        c.globalAlpha = 0.08
        c.fillStyle = '#808080'
        c.textAlign = 'center'
        c.textBaseline = 'middle'
        c.font = 'bold 50px sans-serif'
        c.fillText('自在量化', canvas.width/2, canvas.height/2 - 20)
        c.font = '24px sans-serif'
        c.fillText('quant.zizizaizai.com', canvas.width/2, canvas.height/2 + 20)
        c.restore()
        c.strokeStyle = '#e0e0e0'
        c.lineWidth = 1
        c.fillStyle = '#333333'
        c.font = 'bold 13px sans-serif'
        let x = 0
        let y = 0
        for (let ci=0;ci<colCount;ci++){
          c.fillStyle = '#f5f5f5'
          c.fillRect(x, y, colWidths[ci], 40)
          c.strokeRect(x, y, colWidths[ci], 40)
          c.fillStyle = '#333333'
          c.textAlign = 'left'
          c.textBaseline = 'middle'
          c.fillText(header[ci], x + paddingX, y + 20)
          x += colWidths[ci]
        }
        y += 40
        c.font = font
        const colX = []
        x = 0
        for (let ci=0;ci<colCount;ci++){ colX.push(x); x += colWidths[ci] }
        const groupHeightSum = (start, span) => {
          let h = 0
          for (let k=0;k<span;k++) h += rowHeights[start+k]
          return h
        }
        for (let ri=0;ri<rows.length;ri++){
          const r = rows[ri]
          const h = rowHeights[ri]
          for (let ci=IDX.STOCK;ci<colCount;ci++){
            const cx = colX[ci]
            c.strokeRect(cx, y, colWidths[ci], h)
          }
          const drawMerged = (ci, showFlag, spanProp, textKey) => {
            if (!r[showFlag]) return
            const cx = colX[ci]
            const span = r[spanProp] || 1
            const mh = groupHeightSum(ri, span)
            c.strokeRect(cx, y, colWidths[ci], mh)
            c.textAlign = 'left'
            c.textBaseline = 'top'
            c.fillStyle = '#333333'
            const prevFont = c.font
            c.font = 'bold 12px sans-serif'
            const lines = wrap(r[textKey], colWidths[ci])
            let ty = y + paddingY
            for (let li=0;li<lines.length && li<10;li++){
              c.fillText(lines[li], cx + paddingX, ty)
              ty += 16
            }
            c.font = prevFont
          }
          drawMerged(IDX.L1, '_l1Show', '_l1Span', '一级大类')
          drawMerged(IDX.L2, '_l2Show', '_l2Span', '二级小类')
          drawMerged(IDX.L3, '_l3Show', '_l3Span', '三级细分')
          c.textAlign = 'left'
          c.textBaseline = 'top'
          c.fillStyle = '#333333'
          const stock = String(r['个股'] || '')
          const prevFont2 = c.font
          c.font = 'bold 12px sans-serif'
          c.fillText(stock, colX[IDX.STOCK] + paddingX, y + paddingY)
          c.font = prevFont2
          if (showQ && IDX.CODE >= 0) {
            c.fillStyle = '#333333'
            const code = r.symbol_code || r['股票代码'] || ''
            c.fillText(String(code), colX[IDX.CODE] + paddingX, y + paddingY)
          }
          if (showQ && IDX.CAP >= 0) {
            c.fillStyle = '#333333'
            const cap = r['流通市值']
            const capStr = (cap !== undefined && cap !== null && cap !== '') ? this.formatYi(cap) : ''
            c.fillText(capStr, colX[IDX.CAP] + paddingX, y + paddingY)
          }
          if (showQ && IDX.PRICE >= 0) {
            c.fillStyle = '#333333'
            const price = r['最新价']
            const priceStr = (price !== undefined && price !== null && price !== '') ? String(price) : ''
            c.fillText(priceStr, colX[IDX.PRICE] + paddingX, y + paddingY)
          }
          if (showQ && IDX.RATE >= 0) {
            const rate = r['涨跌幅']
            let rateStr = ''
            if (rate !== undefined && rate !== null && rate !== '') {
              rateStr = String(rate) + '%'
              const rv = parseFloat(rate)
              if (!isNaN(rv)) {
                if (rv > 0) c.fillStyle = '#e33e33'
                else if (rv < 0) c.fillStyle = '#17803d'
                else c.fillStyle = '#333333'
              } else c.fillStyle = '#333333'
            } else c.fillStyle = '#333333'
            c.fillText(rateStr, colX[IDX.RATE] + paddingX, y + paddingY)
          }
          c.fillStyle = '#333333'
          const relLines = wrap(r['相关性'], colWidths[IDX.REL])
          let ty1 = y + paddingY
          for (let li=0;li<relLines.length && li<40;li++){
            c.fillText(relLines[li], colX[IDX.REL] + paddingX, ty1)
            ty1 += 16
          }
          const srcLines = wrap(r['信息源'], colWidths[IDX.SRC])
          let ty2 = y + paddingY
          for (let li=0;li<srcLines.length && li<40;li++){
            c.fillText(srcLines[li], colX[IDX.SRC] + paddingX, ty2)
            ty2 += 16
          }
          y += h
        }
        const a = document.createElement('a')
        const name = (this.editForm.name || '题材表格')
        const ts = this.lastQuoteTime || this.editForm.updated_time || this.formatNow()
        a.href = canvas.toDataURL('image/png')
        a.download = `${name}-${ts}.png`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }catch(e){
        alert('生成图片失败')
        console.error(e)
      }
    },
    downloadTableCsv(){
      const rows = Array.isArray(this.editForm.rows) ? this.editForm.rows : []
      const showQ = this.showQuotes
      const header = showQ
        ? ['一级大类','二级小类','三级细分','个股','股票代码','流通市值','当前价格','涨跌幅','相关性','信息源']
        : ['一级大类','二级小类','三级细分','个股','相关性','信息源']
      const lines = [header.join(',')]
      rows.forEach(row => {
        const cap = showQ ? this.formatYi(row['流通市值']) : ''
        const price = showQ ? (row['最新价'] !== undefined && row['最新价'] !== null ? row['最新价'] : '') : ''
        const rate = showQ && row['涨跌幅'] !== undefined && row['涨跌幅'] !== null ? `${row['涨跌幅']}%` : ''
        const code = showQ ? (row.symbol_code || row['股票代码'] || '') : ''
        const vals = showQ
          ? [
            row['一级大类'] || '',
            row['二级小类'] || '',
            row['三级细分'] || '',
            row['个股'] || '',
            code,
            cap,
            price,
            rate,
            row['相关性'] || '',
            row['信息源'] || ''
          ]
          : [
            row['一级大类'] || '',
            row['二级小类'] || '',
            row['三级细分'] || '',
            row['个股'] || '',
            row['相关性'] || '',
            row['信息源'] || ''
          ]
        const escaped = vals.map(v => `"${String(v).replace(/"/g, '""')}"`)
        lines.push(escaped.join(','))
      })
      const csv = '\uFEFF' + lines.join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const name = this.editForm.name || '题材表格'
      const ts = this.lastQuoteTime || this.editForm.updated_time || this.formatNow()
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `${name}-${ts}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    compressImage(file){
      return new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (e) => {
              const img = new Image()
              img.src = e.target.result
              img.onload = () => {
                  const canvas = document.createElement('canvas')
                  let width = img.width
                  let height = img.height
                  // Max dimension 2048 to be safe and reduce size
                  const MAX_DIM = 2048
                  if(width > MAX_DIM || height > MAX_DIM){
                      if(width > height){
                          height = Math.round(height * MAX_DIM / width)
                          width = MAX_DIM
                      } else {
                          width = Math.round(width * MAX_DIM / height)
                          height = MAX_DIM
                      }
                  }
                  canvas.width = width
                  canvas.height = height
                  const ctx = canvas.getContext('2d')
                  ctx.drawImage(img, 0, 0, width, height)
                  canvas.toBlob((blob) => {
                      if(blob){
                          const newFile = new File([blob], file.name || 'image.jpg', { type: 'image/jpeg', lastModified: Date.now() })
                          resolve(newFile)
                      } else {
                          reject(new Error('Canvas toBlob failed'))
                      }
                  }, 'image/jpeg', 0.7)
              }
              img.onerror = reject
          }
          reader.onerror = reject
      })
    },
    identifyJygs(){
      if(!this.jygsUrl) return
      if(this.jygsUrl.indexOf('jiuyangongshe.com') === -1){
        alert('请输入有效的韭研公社链接')
        return
      }
      this.identifying = true
      request_zzquant({ url:'/topic/jygs/parse', method:'POST', data:{ url: this.jygsUrl } })
        .then(res=>{
          const d = res.data
          if(d.code === 20000 && d.data){
             const info = d.data
             this.form.name = info.title || ''
             this.form.content = info.content || ''
             if(info.create_time) this.$set(this.form, 'create_time', info.create_time)
             if(info.update_time) this.$set(this.form, 'update_time', info.update_time)
             
             let imgUrl = ''
             if(info.images && Array.isArray(info.images) && info.images.length > 0){
                imgUrl = info.images[0]
             } else if (typeof info.images === 'string' && info.images) {
                imgUrl = info.images
             } else if (info.image_url) {
                imgUrl = info.image_url
             } else if (info.imgs) {
                let imgs = info.imgs
                if (typeof imgs === 'string') {
                    try {
                        // Clean up potential markdown or weird chars if needed, though JSON.parse is strict
                        // If it is "[\"url\"]", JSON.parse returns ["url"]
                        const parsed = JSON.parse(imgs)
                        if (Array.isArray(parsed) && parsed.length > 0) {
                            imgUrl = parsed[0]
                        } else if (typeof parsed === 'string') {
                            imgUrl = parsed
                        }
                    } catch (e) {
                        // Fallback: remove brackets/quotes manually if parse fails or it's just a string
                        let s = imgs.replace(/^[["']+|[\]"']+$/g, '')
                        if(s.indexOf(',') > -1) s = s.split(',')[0]
                        imgUrl = s.trim()
                    }
                } else if (Array.isArray(imgs) && imgs.length > 0) {
                     imgUrl = imgs[0]
                }
             }

             if(imgUrl){
                // Remove potential backticks or extra quotes if parsing was messy
                imgUrl = imgUrl.replace(/[`]/g, '').trim()
                this.form.image = null
                this.$set(this.form, 'image_url', imgUrl)
                this.imagePreview = imgUrl
                // this.recognizeImage()
             }
             this.showRecognitionArea = true
             this.switchToRecognitionJsonMode()
             this.$bvToast.toast('获取成功', { variant:'success', solid:true })
          } else {
             alert(d.message || '识别失败')
          }
        })
        .catch(err=>{ console.error(err); alert('请求失败') })
        .finally(()=>{ this.identifying = false })
    },
    handlePaste(event){
      const items = (event.clipboardData || event.originalEvent.clipboardData).items
      for (let index in items) {
        const item = items[index]
        if (item.kind === 'file' && item.type.indexOf('image/') !== -1) {
          const blob = item.getAsFile()
          if (this.showEdit) {
             this.editForm.image = blob
             this.onEditImageChange(blob)
             // Auto recognize if desired, or just show preview
          } else {
             this.form.image = blob
             this.onImageChange(blob)
          }
          event.preventDefault()
          return
        }
      }
    },
    onImageChange(file){ 
      if (file) { 
        try { this.imagePreview = URL.createObjectURL(file) } catch(e){ this.imagePreview='' } 
      } else { 
        this.imagePreview = this.form.image_url || '' 
      } 
    },
    onImageUrlChange(val){
      if(!this.form.image){
         this.imagePreview = val
      }
    },
    onEditImageChange(file){ if (file) { try { this.editImagePreview = URL.createObjectURL(file) } catch(e){ this.editImagePreview='' } } else { this.editImagePreview='' } },
    getFirstItem(content) {
      if (!content) return '';
      let c = String(content);
      
      // Regex for "2、" or "2." at start of line or start of string
      const regex = /(^|\n)\s*2[、.]/;
      const match = c.match(regex);
      if (match) {
          return c.substring(0, match.index).trim();
      }
      
      // Fallback: first line
      const newlineIdx = c.indexOf('\n');
      if (newlineIdx > -1) {
          return c.substring(0, newlineIdx).trim();
      }
      
      return c;
    },
    loadTables(page=1){

      this.loading = true
      this.currentPage = page
      request_zzquant({ url:'/topic/tables', method:'GET', params:{ page: this.currentPage, limit: this.perPage, brief: 1 } })
        .then(res=>{
          const d = res && res.data && res.data.data ? res.data.data : {}
          if(Array.isArray(d)){
             // Compatible with old format if backend not updated immediately
             this.tables = d
             this.totalRows = d.length
          } else {
             this.tables = Array.isArray(d.items) ? d.items : []
             this.totalRows = d.total || 0
          }
        })
        .catch(()=>{ this.tables = [] })
        .finally(()=>{ this.loading = false })
    },
    async recognizeImage(){
      if(!this.form.image && !this.form.image_url){ this.ocrMsg = '请先选择图片'; return }
      this.submitting = true
      this.showRecognitionArea = true
      this.ocrMsg = '正在处理图片…'
      
      let fileToUpload = this.form.image
      if(fileToUpload){
          try {
              fileToUpload = await this.compressImage(fileToUpload)
          } catch(e) {
              console.error('Compression failed, using original', e)
          }
      }

      this.ocrMsg = '正在识别…'
      const fd = new FormData()
      if(fileToUpload) fd.append('image', fileToUpload)
      else if(this.form.image_url) fd.append('image_url', this.form.image_url)
      fd.append('engine', 'qwen')
      request_zzquant({ url:'/topic/table/ocr', method:'POST', data: fd, headers:{ 'Content-Type':'multipart/form-data' }, timeout: 180000 })
        .then(res=>{
          const d = res.data || {}
          if(d.code === 20000){
            const rows = d.data || []
            this.recognized = Array.isArray(rows) ? rows : []
            this.ocrMsg = this.recognized.length ? '识别成功' : '未识别到表格内容'
          } else {
            const msg = d.data || d.message || '识别失败'
            this.recognized = []
            this.ocrMsg = typeof msg === 'string' ? msg : '识别失败'
          }
        })
        .catch(err=>{ const msg = (err && err.message) ? String(err.message) : '识别失败'; this.recognized = []; this.ocrMsg = msg })
        .finally(()=>{ this.submitting = false })
    },
    async recognizeEditImage(mode = 'overwrite'){
      if(!this.editForm.image){ this.editOcrMsg = '请先选择图片'; return }
      this.submitting = true
      this.editOcrMsg = '正在处理图片…'
      
      let fileToUpload = this.editForm.image
      try {
          fileToUpload = await this.compressImage(fileToUpload)
      } catch(e) {
          console.error('Compression failed, using original', e)
      }

      this.editOcrMsg = '正在识别…'
      const fd = new FormData()
      fd.append('image', fileToUpload)
      fd.append('engine', 'qwen')
      request_zzquant({ url:'/topic/table/ocr', method:'POST', data: fd, headers:{ 'Content-Type':'multipart/form-data' }, timeout: 60000 })
        .then(res=>{
          const d = res.data || {}
          if(d.code === 20000){
            const rows = d.data || []
            const newRows = Array.isArray(rows) ? rows : []
            if (mode === 'append') {
              this.editForm.rows = [...(this.editForm.rows || []), ...newRows]
              this.editOcrMsg = newRows.length ? '识别成功并已追加内容' : '未识别到表格内容'
            } else {
              this.editForm.rows = newRows
              this.editOcrMsg = newRows.length ? '识别成功并已覆盖内容' : '未识别到表格内容'
            }
          } else {
            const msg = d.data || d.message || '识别失败'
            this.editOcrMsg = typeof msg === 'string' ? msg : '识别失败'
          }
        })
        .catch(err=>{ const msg = (err && err.message) ? String(err.message) : '识别失败'; this.editOcrMsg = msg })
        .finally(()=>{ this.submitting = false })
    },
    createTable(){
      if(!this.canEdit) return
      const name = (this.form.name||'').trim()
      const content = (this.form.content||'').trim()
      if(!name) return
      this.submitting = true
      const fd = new FormData()
      fd.append('name', name)
      fd.append('content', content)
      if(this.form.create_time) fd.append('created_time', this.form.create_time)
      if(this.form.update_time) fd.append('updated_time', this.form.update_time)
      if(this.form.image) fd.append('image', this.form.image)
      else if(this.form.image_url) fd.append('image_url', this.form.image_url)
      if(this.recognized && this.recognized.length) fd.append('rows', JSON.stringify(this.recognized))
      request_zzquant({ url:'/topic/table/create', method:'POST', data: fd })
        .then(res=>{
          const d = res.data || {}
          if(d.code === 20000){
            this.form={ name:'', content:'', image:null, image_url:'', create_time:'', update_time:'' }
            this.imagePreview=''
            this.recognized=[]
            this.loadTables()
            // this.$bvToast.toast('创建成功', { variant:'success', solid:true })
          } else {
            const msg = d.data || d.message || '创建失败'
            alert(typeof msg === 'string' ? msg : '创建失败')
          }
        })
        .catch(err=>{ console.error(err); alert('请求失败') })
        .finally(()=>{ this.submitting=false })
    },
    selectTable(item){ 
      sessionStorage.setItem('current_topic', JSON.stringify(item));
      this.$router.push({ path: `/wonder/topic/detail/${item.id}` });
    },
    editTable(item){ 
      sessionStorage.setItem('current_topic', JSON.stringify(item));
      this.$router.push({ path: `/wonder/topic/detail/${item.id}`, query: { edit: 1 } });
    },
    generateMindMap(){
      const data = { name: this.editForm.name || '题材', children: [] };
      const map = {};
      // Layout config
      const layoutMap = {
          'LR': { orient: 'LR', top: '5%', left: '5%', bottom: '5%', right: '70%', labelPos: 'left', leafLabelPos: 'right', labelAlign: 'right', leafLabelAlign: 'left' },
          'RL': { orient: 'RL', top: '5%', left: '70%', bottom: '5%', right: '5%', labelPos: 'right', leafLabelPos: 'left', labelAlign: 'left', leafLabelAlign: 'right' },
          'TB': { orient: 'TB', top: '5%', left: '5%', bottom: '70%', right: '5%', labelPos: 'top', leafLabelPos: 'bottom', labelAlign: 'center', leafLabelAlign: 'center', labelVertical: 'bottom', leafLabelVertical: 'top' },
          'BT': { orient: 'BT', top: '70%', left: '5%', bottom: '5%', right: '5%', labelPos: 'bottom', leafLabelPos: 'top', labelAlign: 'center', leafLabelAlign: 'center', labelVertical: 'top', leafLabelVertical: 'bottom' }
      };
      const currentStyle = layoutMap[this.mindMapStyle] || layoutMap['LR'];
      const stockLabel = {
          position: currentStyle.leafLabelPos,
          verticalAlign: currentStyle.leafLabelVertical || 'middle',
          align: currentStyle.leafLabelAlign,
          fontSize: 12,
          rotate: (this.mindMapStyle === 'TB' || this.mindMapStyle === 'BT') ? 90 : 0
      };

      (this.editForm.rows || []).forEach(row => {
          const l1 = (row['一级大类'] || '其他').trim();
          const l2 = (row['二级小类'] || '').trim();
          const l3 = (row['三级细分'] || '').trim();
          const stock = (row['个股'] || '').trim();
          if (!stock) return;

          let stockName = stock;
          let nodeColor = undefined;
          let nodeFontWeight = undefined;

          if (this.showQuotes && row['涨跌幅'] !== undefined && row['涨跌幅'] !== null) {
             stockName += ` (${row['涨跌幅']}%)`;
             const rate = parseFloat(row['涨跌幅']);
             if (!isNaN(rate)) {
                if (rate > 9) {
                    nodeColor = 'red';
                    nodeFontWeight = 'bold';
                } else if (rate > 0) {
                    nodeColor = 'red';
                } else if (rate < 0) {
                    nodeColor = 'green';
                }
             }
          }

          if (!map[l1]) map[l1] = {};
          if (!map[l1][l2]) map[l1][l2] = {};
          if (!map[l1][l2][l3]) map[l1][l2][l3] = [];

          map[l1][l2][l3].push({ 
             name: stockName, 
             value: row['相关性'] || '', 
             source: row['信息源'] || '',
             color: nodeColor,
             fontWeight: nodeFontWeight
          });
      });

      // Colors for different branches
      const colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];
      let colorIndex = 0;

      for (const l1 in map) {
          const color = colors[colorIndex % colors.length];
          colorIndex++;
          const l1Node = { 
            name: l1, 
            children: [],
            itemStyle: { color: color, borderColor: color },
            lineStyle: { color: color }
          };
          for (const l2 in map[l1]) {
                  let l2Parent = l1Node;
                  if (l2) {
                    const l2Node = { 
                      name: l2, 
                      children: [],
                      itemStyle: { color: color, borderColor: color },
                      lineStyle: { color: color }
                    };
                    l1Node.children.push(l2Node);
                    l2Parent = l2Node;
                  }

                  for (const l3 in map[l1][l2]) {
                      let l3Parent = l2Parent;
                      if (l3) {
                          const l3Node = { 
                              name: l3, 
                              children: [],
                              itemStyle: { color: color, borderColor: color },
                              lineStyle: { color: color }
                          };
                          l2Parent.children.push(l3Node);
                          l3Parent = l3Node;
                      }

                      map[l1][l2][l3].forEach(s => {
                          const stockNode = {
                              name: s.name,
                              children: [],
                              itemStyle: { color: color, borderColor: color },
                              lineStyle: { color: color },
                              label: {
                                  ...stockLabel,
                                  color: s.color,
                                  fontWeight: s.fontWeight
                              }
                          };
                          // Helper to truncate text
                          const truncate = (str, len=200) => str.length > len ? str.substring(0, len) + '...' : str;
                          
                          let lastNode = stockNode;
        
                          if(s.source) {
                            const sourceNode = { 
                              name: truncate(s.source) + '：' + truncate(s.value),
                              value: s.source, // Store full text for tooltip
                              itemStyle: { color: color, borderColor: color },
                              lineStyle: { color: color },
                              children: []
                            };
                            lastNode.children.push(sourceNode);
                            lastNode = sourceNode;
                          }
                          
                          l3Parent.children.push(stockNode);
                      });
                  }
              }
          data.children.push(l1Node);
      }

      const getLayoutOption = (style) => {
          const base = {
              type: 'tree',
              data: [data],
              symbol: this.mindMapSymbol,
              edgeShape: this.mindMapCurve,
              symbolSize: 7,
              roam: true,
              expandAndCollapse: true,
              initialTreeDepth: -1,
              animationDuration: 550,
              animationDurationUpdate: 750
          };
          
          if (style === 'radial') {
              return {
                  ...base,
                  layout: 'radial',
                  top: '10%', left: '10%', bottom: '10%', right: '10%',
                  label: { position: 'right', verticalAlign: 'middle', align: 'left', fontSize: 12 },
                  leaves: { label: { position: 'right', verticalAlign: 'middle', align: 'left' } }
              };
          }
          
          const opt = layoutMap[style] || layoutMap['LR'];
          return {
              ...base,
              layout: 'orthogonal',
              orient: opt.orient,
              top: opt.top, left: opt.left, bottom: opt.bottom, right: opt.right,
              label: { 
                  position: opt.labelPos, 
                  verticalAlign: opt.labelVertical || 'middle', 
                  align: opt.labelAlign, 
                  fontSize: 12,
                  rotate: (style === 'TB' || style === 'BT') ? 90 : 0
              },
              leaves: { 
                  label: { 
                      position: opt.leafLabelPos, 
                      verticalAlign: opt.leafLabelVertical || 'middle', 
                      align: opt.leafLabelAlign,
                      rotate: (style === 'TB' || style === 'BT') ? 90 : 0
                  } 
              }
          };
      };

      this.mindMapOption = {
          title: [
            {
              text: this.editForm.updated_time ? '题材更新时间：' + this.editForm.updated_time : '',
              top: 10,
              left: 10,
              textStyle: { fontSize: 12, color: '#999', fontWeight: 'normal' }
            },
            {
              text: this.lastQuoteTime ? '行情更新时间：' + this.lastQuoteTime : '',
              top: 10,
              right: 10,
              textStyle: { fontSize: 12, color: '#999', fontWeight: 'normal' }
            }
          ],
          backgroundColor: this.theme === 'dark' ? '#1c1c1e' : '#ffffff',
          tooltip: { 
            trigger: 'item', 
            triggerOn: 'mousemove',
            formatter: (params) => {
              // Show full text if available in value, otherwise name
              return params.data.value ? params.data.value : params.name;
            }
          },
          series: [getLayoutOption(this.mindMapStyle)],
          graphic: [
            {
              type: 'text',
              z: -10,
              right: 20,
              bottom: 60,
              style: {
                fill: '#e0e0e0',
                text: '自在量化',
                font: 'bold 50px sans-serif'
              }
            },
            {
              type: 'text',
              z: -10,
              right: 20,
              bottom: 20,
              style: {
                fill: '#e0e0e0',
                text: 'quant.zizizaizai.com',
                font: '24px sans-serif'
              }
            },
            {
              type: 'text',
              z: -10,
              left: 'center',
              bottom: 10,
              style: {
                fill: '#999999',
                text: '声明：本文涉及的资讯、数据等内容来自网络公共信息，我们对以上信息的准确性和完整性不做任何保证，涉及的信息随时都可能会有新变化，仅作为学习交流之用。',
                font: '12px sans-serif'
              }
            }
          ]
      };
    },
    changeMindMapStyle(style){
      this.mindMapStyle = style;
      this.generateMindMap();
    },
    changeMindMapCurve(curve){
      this.mindMapCurve = curve;
      this.generateMindMap();
    },
    changeMindMapSymbol(symbol){
      this.mindMapSymbol = symbol;
      this.generateMindMap();
    },
    queryStockReturns(){
      if(!this.editForm.rows || !this.editForm.rows.length) return
      
      const stocks = this.editForm.rows.map(r => r['个股']).filter(s => s && s.trim())
      if(!stocks.length){
        alert('没有找到个股代码')
        return
      }
      
      this.loadingStocks = true
      this.lastQuoteTime = this.formatNow()
      
      request_zzquant({ 
        url:'/topic/table/stock-returns', 
        method:'POST', 
        data: { stocks } 
      })
      .then(res => {
         const d = res.data
         if(d.code === 20000){
            const result = d.data || {}
            // Update rows with new data
            let updatedCount = 0
            const pickCircCap = (obj) => {
              if (!obj || typeof obj !== 'object') return ''
              const keys = ['circ_cap','circulation_cap','circulating_cap','circ','circ_price','circ_value','circulation_value']
              for (let i=0;i<keys.length;i++){
                const k = keys[i]
                if (obj[k] !== undefined && obj[k] !== null) return obj[k]
              }
              return ''
            }
            this.editForm.rows = this.editForm.rows.map(row => {
               const stock = (row['个股'] || '').trim()
               if(stock && result[stock]){
                  updatedCount++
                  return {
                     ...row,
                     '涨跌幅': result[stock].px_change_rate,
                     '最新价': result[stock].last_px,
                     '流通市值': pickCircCap(result[stock]),
                     'symbol_code': result[stock].symbol || result[stock].code || result[stock].ts_code || result[stock].symbol_code
                  }
               }
               return row
            })
            
            // Refresh mind map to show price changes
            if(this.viewMode === 'mindmap'){
               this.generateMindMap()
            }

            this.$bvToast.toast(`已更新 ${updatedCount} 个股票行情`, { variant:'success', solid:true })
         } else {
            alert(d.message || '查询失败')
         }
      })
      .catch(e => {
         console.error(e)
         alert('查询出错')
      })
      .finally(() => {
         this.loadingStocks = false
      })
    },
    onToggleQuotes(val){
      if(val){
        this.queryStockReturns()
      } else {
        // Just regenerate the mindmap to remove rate color/label
        if(this.viewMode === 'mindmap'){
          this.generateMindMap()
        }
      }
    },
    formatNow(){
      const d = new Date()
      const pad = n => String(n).padStart(2, '0')
      const y = d.getFullYear()
      const m = pad(d.getMonth()+1)
      const day = pad(d.getDate())
      const hh = pad(d.getHours())
      const mm = pad(d.getMinutes())
      const ss = pad(d.getSeconds())
      return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
    },
    switchToJsonMode(){
      this.jsonStr = JSON.stringify(this.editForm.rows, null, 2);
      this.viewMode = 'json';
    },
    enterMindMapFullscreen(){
      const el = this.$refs.mindmapContainer
      if (!el) return
      try {
        if (el.requestFullscreen) el.requestFullscreen()
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen()
        else if (el.msRequestFullscreen) el.msRequestFullscreen()
      } catch(e) { console.warn('enterMindMapFullscreen failed', e) }
    },
    downloadMindMap(){
      const chartRef = this.$refs.mindmapChart
      if (!chartRef) { alert('未找到图表'); return }
      let inst = null
      try {
        if (typeof chartRef.getEchartsInstance === 'function') {
          inst = chartRef.getEchartsInstance()
        } else if (chartRef.chart) {
          inst = chartRef.chart
        } else if (chartRef.echarts) {
          inst = chartRef.echarts
        }
      } catch(e) { console.warn('get chart instance failed', e) }
      if (!inst || typeof inst.getDataURL !== 'function') { alert('无法获取图像'); return }
      const dataURL = inst.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#ffffff' })
      const a = document.createElement('a')
      const name = (this.editForm.name || '思维导图')
      const ts = this.lastQuoteTime || this.editForm.updated_time || ''
      a.href = dataURL
      a.download = `${name}-${ts || 'snapshot'}.png`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    switchToTableMode(){
      if(this.viewMode === 'json'){
        this.syncJsonToRows();
      }
      this.viewMode = 'table';
    },
    switchToMindMap(){
      this.viewMode = 'mindmap';
      this.generateMindMap();
    },
    syncJsonToRows(){
       try {
          const parsed = JSON.parse(this.jsonStr);
          if (Array.isArray(parsed)) {
            this.editForm.rows = parsed;
            this.jsonError = '';
          } else {
            this.jsonError = 'JSON必须是数组格式';
          }
        } catch (e) {
          this.jsonError = 'JSON格式错误: ' + e.message;
        }
    },
    updateTable(){
      if (this.viewMode === 'json') {
          this.syncJsonToRows();
          if (this.jsonError) {
             alert(this.jsonError);
             return;
          }
      }
      if(!this.canEdit || !this.editId) return
      this.submitting = true
      const payload = { 
        name: this.editForm.name, 
        content: this.editForm.content, 
        rows: this.editForm.rows,
        created_time: this.editForm.created_time,
        updated_time: this.editForm.updated_time
      }
      request_zzquant({ url:'/topic/table/update/'+this.editId, method:'POST', data: payload })
        .then(res=>{
          const d = res.data || {}
          if(d.code === 20000){
            this.showEdit=false
            this.loadTables()
          } else {
            const msg = d.data || d.message || '更新失败'
            alert(typeof msg === 'string' ? msg : '更新失败')
          }
        })
        .catch(err=>{ console.error(err); alert('请求失败') })
        .finally(()=>{ this.submitting=false })
    },
    addRow(index) {
      const newRow = {
        '一级大类': '',
        '二级小类': '',
        '三级细分': '',
        '个股': '',
        '相关性': '',
        '信息源': ''
      };
      this.editForm.rows.splice(index + 1, 0, newRow);
    },
    getRateStyle(rate) {
        if (rate === undefined || rate === null) return {};
        const r = parseFloat(rate);
        if (isNaN(r)) return {};
        if (r > 9) return { color: 'red', fontWeight: 'bold' };
        if (r > 5) return { color: 'red', fontWeight: 'bold' };
        if (r > 0) return { color: 'red' };
        if (r < 0) return { color: 'green' };
        return {};
    },
    switchToRecognitionJsonMode(){
      this.recognitionJsonStr = JSON.stringify(this.recognized, null, 2);
      this.recognitionView = 'json';
    },
    syncRecognitionJsonToTable(){
       try {
          const parsed = JSON.parse(this.recognitionJsonStr);
          if (Array.isArray(parsed)) {
            this.recognized = parsed;
            this.recognitionJsonError = '';
          } else {
            this.recognitionJsonError = 'JSON必须是数组格式';
          }
        } catch (e) {
          this.recognitionJsonError = 'JSON格式错误: ' + e.message;
        }
    },
    addRecognizedRow(){
      this.recognized.push({
        '一级大类': '',
        '二级小类': '',
        '三级细分': '',
        '个股': '',
        '相关性': '',
        '信息源': '',
        '涨跌幅': '',
        '最新价': ''
      })
    },
    openSidebar(item) {
        if (!item || !item.symbol_code) {
             // Try to use stock name if code is missing, though sidebar needs code usually.
             // But let's just warn or do nothing if no code.
             // Or maybe we can try to guess? No, let's rely on queryStockReturns populating it.
             if (this.showQuotes && item['个股']) {
                 // Maybe alert user to refresh quotes?
                 console.warn('No symbol code for stock:', item['个股'])
             }
             return
        }
        this.sidebarSymbolCode = item.symbol_code
        this.sidebarSymbolName = item['个股']
        this.sidebarDateMark = '' // Current date by default
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right-stock')
    },
    onRowClicked(item){ this.selectTable(item) }
  }
}
</script>

<style>
/* 去掉之前的modal样式 */
.cursor-pointer {
  cursor: pointer;
}
@media (max-width: 768px) {
  .wonder-table-view-small td.col-content { min-width: 150px; }
  
  /* 移动端字体与间距 */
  .wonder-table-view-small th, 
  .wonder-table-view-small td {
    padding: 2px !important;
    font-size: 10px !important;
  }
}

/* Mobile optimizations */
@media (max-width: 768px) {
  /* ... existing styles ... */
  
  /* Hide content column on mobile */
  ::v-deep .table .d-none.d-md-table-cell {
    display: none !important;
  }
}
.mindmap-container {
  background-color: var(--bg-card, #ffffff);
}
</style>

<style scoped>
/* Scoped styles */
::v-deep .table td {
  vertical-align: middle;
}
::v-deep .table th {
  border-top: none;
  background-color: var(--bg-muted);
  color: var(--text-muted);
}
</style>

